<template>
  <div class="borrow" v-show="borrowList.length>0">
    <header class="borrow-header">
      精选推荐
      <span class="sub">连续申请3家，成功率高达<em>90%</em>以上</span>
    </header>
    <main>
      <div v-for="(item,index) in borrowList"
           :key="index" class="item"
           @click="borrowMoney(item, index)"
           :data-sensors-exposure-property-product_code="item.configId"
           data-sensors-exposure-property-element_positon="product_list"
           data-sensors-exposure-property-product_type="diversion"
           data-sensors-exposure-event-name="Diversion_Exposure"
      >
        <div class="top">
          <div class="top-left">
            <img :src="item.icon||require('./images/banner.png')"/>
            <span class="top-left-more">{{item.productName}}</span>
          </div>
          <div class="top-right"><span>{{item.buttonName}}</span></div>
        </div>
        <div class="bottom">
          <div class="bottom-left">
            <div class="bottom-left-limit">额度高达 (元) </div>
            <div class="bottom-left-money">{{item.configLimit|currency}}</div>
          </div>
          <div class="bottom-right">
            <div class="bottom-right-desc">{{item.productDesc}}</div>
            <div class="bottom-right-year">年化利率 {{item.minPrice}}%-{{item.maxPrice}}%</div>
          </div>
        </div>
      </div>
    </main>
    <footer class="mt20" @click="jumpRiver">
      <div class="guang"></div>
      <span>更多借款</span>
      <img src="./images/arrow@2x.png"/>
    </footer>
    <div class="fixed" v-show="isFixed" ref="borrow">
      <footer @click="jumpRiver">
        <div class="guang"></div>
        <span>更多借款</span>
        <img src="./images/arrow@2x.png"/>
      </footer>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getKey } from '@/assets/utils'

export default {
  name: 'borrow-list',
  data () {
    return {
      borrowList: [], // 借款列表
      isFixed: false      
    }
  },
  watch: {
    countdownVisible (value) {
      console.log('borrow-list reload', value)
      this.setupFixViewHeight()
      this.reload()
    },
    overdueFloatViewVisible (value) {
      console.log('borrow-list reload', value)
      this.setupFixViewHeight()
      this.reload()
    },
    fllowAccountViewVisible (value) {
      console.log('borrow-list reload', value)
      this.setupFixViewHeight()
      this.reload()
    }
  },
  props: {
    source: {
      default: '',
      type: String
    },
    status: {
      default: '',
      type: String
    },
    title: {
      default: '',
      type: String
    },
    type: {
      default: '',
      type: String
    },
    countdownVisible: {
      default: false,
      type: Boolean
    },
    overdueFloatViewVisible: {
      default: false,
      type: Boolean
    },
    fllowAccountViewVisible: {
      default: false,
      type: Boolean
    },
    equityList: Boolean
  },
  computed: {
    fixedHeight () {
      return this.countdownVisible ? 100 : this.overdueFloatViewVisible ? 150 : this.fllowAccountViewVisible ? 130 : 0
    }
  },
  created () {
    this.$nextTick(() => {
      this.setupFixViewHeight()
    })
    this.init()
  },
  methods: {
    ...mapActions('user', ['getBorrowList']),
    ...mapActions(['dataPoint']),
    async init () {
      const response = await this.getBorrowList({ showPlace: 'HOME', queryBanner: false, version: 'V2' })
      if (response.success) {
        const { configs } = response.data
        this.borrowList = configs || []
        if (this.borrowList.length > 1) {
          this.isFixed = true
        }
        this.borrowList.map(item => {
          this.$report({
            id: 10002,
            args: { position: this.type, target: item.configId, step: this.status }
          })
        })
      }
    },
    // 高度变化
    reload (e) {
      let allHeight = 0
      if (document.getElementsByClassName('page') && document.getElementsByClassName('page').length) {
        allHeight = document.getElementsByClassName('page')[0].offsetHeight
      }
      let height = window.innerHeight || document
      const scrollTop = e?.target?.scrollTop || 0
      let fontSize = document.documentElement.style.fontSize || ''
      // let tabbar = (document.getElementsByClassName('nd-tabbar')[0].offsetHeight - 48)
      let number = ((Number(fontSize.replace('px', '')) / 75) * 530)
      if (allHeight - height - scrollTop <= number - this.fixedHeight) {
        this.isFixed = false
      } else {
        this.isFixed = true
      }
    },
    // 跳转导流界面
    jumpRiver (e) {
      e.stopPropagation()
      this.$report({
        id: 10269,
        args: {
          screen: this.type, status: 'all', step: this.status
        }
      })
      this.dataPoint(
        {
          id: 10269, screen: this.type, status: 'all', step: this.status
        }
      )// 同步埋点
      this.$router.push({ path: '/river/diversion', query: { source: encodeURIComponent(this.source) } })
    },
    // 去借款
    borrowMoney (item = {}, index) {
      if (!getKey('userInfo', 'token')) {
        return this.$router.push('/user/login')
      }
      const { directionUrl, configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } = item
      this.$sensors.track('Diversion_Click', { product_type: 'diversion', element_positon: 'product_list', product_code: configId })
      this.$report({
        id: 10269,
        args: {
          screen: this.type, status: 'borrowMoney', step: this.status, target: configId, type: index
        }
      })
      this.dataPoint(
        {
          id: 10269, screen: this.type, status: 'borrowMoney', step: this.status, target: configId, type: index
        }
      )// 同步埋点
      this.$router.push({ path: '/river/middle', query: { directionUrl: encodeURIComponent(directionUrl), configId, productName, logo, source: encodeURIComponent(this.source), configLimit, needExLogin, autoJump, diversionMode } })
    },
    setupFixViewHeight () {
      document.querySelector('body').addEventListener('scroll', this.reload, true)
      let tabbar = document.getElementsByClassName('nd-tabbar')[0].offsetHeight
      let fontSize = document.documentElement.style.fontSize || ''
      let number = 126 * (Number(fontSize.replace('px', '')) / 75) + tabbar
      this.$refs['borrow'].style.height = `${number + this.fixedHeight}px`
    }
  }
}
</script>
<style scoped lang="less">
@import "../../../../assets/less/mixin.less";

.borrow{
  margin:30px auto 0;
  position: relative;
  .borrow-header{
    font-size: 38px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #333333;
    line-height: 53px;
    padding: 0 40px;
    .sub{
      font-size: 24px;
      font-weight: normal;
      color: #666666;
      em{
        color: #FF3446;
        font-style: normal;
      }
    }
  }
  main{
    .item{
      width: 670px;
      background: white;
      border-radius: 20px;
      margin:20px auto 0;
      padding:0 30px;
      position:relative;
      .top{
        height:90px;
        border-bottom:1px solid #EEE;
        display: flex;
        align-items:center;
        justify-content:space-between;
        &-left{
          display: flex;
          justify-content:space-between;
          align-items:center;
          >img{
            width:60px;
            height:60px;
            border-radius: 10px;
          }
          &-more{
            margin-left:14px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }
        &-right{
          width: 170px;
          height: 60px;
          line-height: 60px;
          text-align:center;
          background: #EBF0F9;
          border-radius: 30px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          background: #FFF4F4;
          margin-right: 30px;
          >span{
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF4633;
          }
        }
      }
      .top::after{
        content:'';
        display: block;
        width:71px;
        height:71px;
        position: absolute;
        top:0;
        right:0;
        background:url('./images/img_jiaobiao@2x.png');
        background-size:cover;
      }
      .bottom{
        display: flex;
        justify-content: space-between;
        align-items:center;
        // height: 160px;
        padding:39px 0;
        &-left{
          display: flex;
          flex-direction:column;
          align-items:space-between;
          justify-content: center;
          height: 85px;
          width:200px;
          &-limit{
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
          &-money{
            font-size: 40px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
            color: #333333;
          }
        }
        &-right{
          width:288px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          &-desc{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          &-year{
            margin-top:7px;
          }
        }
      }
    }
  }
  .fixed{
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background: #F7F7F7;
    width: 100%;
  }
  .mt20{
    margin:20px auto 30px;
  }
  footer{
    overflow: hidden;
    position: relative;
    width: 670px;
    height: 88px;
    line-height: 88px;
    background: linear-gradient(270deg, #7E8FF6 0%, #FF4633 100%);
    border-radius: 20px;
    text-align: center;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin:20px auto 0;
    >img{
      width:10px;
      height:17px;
      margin-left:8px;
    }
  }
  .guang{
    position:absolute;
    animation: rotate 1.5s linear infinite;
    width:200px;
    height:100%;
    // transform:rotate(150deg);
    background:url('./images/guang.png');
    background-size:cover;
    }
    @keyframes rotate {
      0% {
          left:0
      }
      100% {
          left:620px;
      }
  }
}
</style>